module.exports = __webpack_public_path__ + "static/EricFan-1f5d1138a63d2f5441f139efcf268bf3.png";